import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


type ImageProps = {
	width: number;
	height: number;
}

const Root = styled.div`
	position: relative;
	display: inline-flex;
	flex-flow: column nowrap;
	align-items: center;
`;

const ImageStyled = styled.img`
	width: 85px;
	height: 85px;
	object-fit: cover;
	object-position: center;

	${(p: ImageProps) => p.width && `
		width: ${p.width}px;
	`}

	${(p: ImageProps) => p.height && `
		height: ${p.height}px;
	`}
`;

const ImageFallback = styled.div`
	border: 1px solid #eee;
	cursor: pointer;

	${(p: ImageProps) => p.width && `
		width: ${p.width}px;
	`}

	${(p: ImageProps) => p.height && `
		height: ${p.height}px;
	`}

	${(p: WithThemeProps) => p.theme && `
		border-color: ${p.theme.palette.accentPrimaryDisabled};
	`}
`;

export {
	Root,
	ImageStyled,
	ImageFallback,
};
